import { DocumentGroup, DocumentType } from 'api/documents/types'

export type DocumentsControlProps = {
  documentType: keyof typeof DocumentType
  documents: { actual: DocumentGroup; archieved: DocumentGroup[] }
  onReload: () => void
}

export enum DocumentsModalVariant {
  Add = 'add',
  Replace = 'replace',
}

export type ModalVariant = DocumentsModalVariant | null
